import {Button} from 'shells/button/button';

interface Props {
    onClick: () => void;
}

export function CloseButton(props: Props) {
    return (
        <Button variant='text-secondary' size='normal' onClick={props.onClick} noPadding={true}>
            Close
        </Button>
    );
}
